import { NavigationModal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { generalTranslations } from 'locale/general'
import { useTranslation } from 'react-i18next'

type InsufficientSafeguardingOfficersProps = {
  showModal: boolean
  handleModalClose: () => void
}

const InsufficientSafeguardingOfficers = ({
  showModal,
  handleModalClose
}: InsufficientSafeguardingOfficersProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <NavigationModal
      modalTitle={t(generalTranslations.ASSIGN_AT_LEAST_1_SAF_OFFICER)}
      modalContentText={t('PREVENT_LOST_LOG_DATA')}
      modalConfirmText={t('CLOSE')}
      showPrompt={showModal}
      confirmNavigation={handleModalClose}
      cancelNavigation={handleModalClose}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <Text weight="bold">{t('TURN_OFF_SAFEGUARDING')}</Text>
    </NavigationModal>
  )
}

export default InsufficientSafeguardingOfficers
